module.exports = __webpack_public_path__ + "img/friend-2.293b7213.png";